import { render, staticRenderFns } from "./TaskPopup.vue?vue&type=template&id=fbc4ccb0&"
import script from "./TaskPopup.vue?vue&type=script&lang=js&"
export * from "./TaskPopup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports